// Core Modules
import { Component, inject, OnInit } from '@angular/core';

// External Modules
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

// Services
import { AuthService } from '@core/services/auth/auth.service';
import { ConfigService } from '@core/services/config/config.service';
import { SessionManagerService } from '@core/services/session-manager/session-manager.service';

// Models
import { HeaderContentModel } from '@shared/models/header-content.model';
import { IUserProfileBasedOnFields } from '@shared/models/auth0-types.model';

// Enums
import { UserProfileFieldsEnum } from '@shared/enum/user-profile-fields.enum';

@Component({
  selector: 'app-user-settings',
  templateUrl: './user-settings.component.html',
  styleUrl: './user-settings.component.scss',
  standalone: true,
  imports: [NgbDropdownModule],
})
export class UserSettingsComponent implements OnInit {
  // Injectors
  private readonly auth = inject(AuthService);
  private readonly configService = inject(ConfigService);
  private readonly sessionManager = inject(SessionManagerService);

  // Private Members
  private userProfile?: IUserProfileBasedOnFields;

  // Public Members
  public headerContents: HeaderContentModel = this.configService.getContents('header');
  public userEmailName?: string;
  public userNameInitials?: string;

  public ngOnInit(): void {
    this.userProfile = this.auth.getUserProfileBasedOnFields([UserProfileFieldsEnum.EMAIL, UserProfileFieldsEnum.HG_CUSTOMER]);
    this.userEmailName = this.userProfile?.email ? this.userProfile.email : 'NOT_AVAILABLE';
    this.getUserNameInitials();
  }

  public getUserNameInitials(): void {
    if (this.userEmailName && this.userEmailName !== 'NOT_AVAILABLE') {
      this.userNameInitials = this.userEmailName.charAt(0).toUpperCase();
    }
  }

  public logout(): void {
    this.sessionManager.stopWatching();
    this.auth.logout();
  }
}
